import { render, staticRenderFns } from "./ChangePasswordComponent.vue?vue&type=template&id=2a175ab2"
import script from "./ChangePasswordComponent.js?vue&type=script&lang=js&external"
export * from "./ChangePasswordComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports